<template>
  <article class="group flex w-full" data-component="CardOverview">
    <AtomLink :url="url" class="flex w-full bg-white border-r-2 border-solid border-app-green rounded-lg overflow-hidden sm:flex-col sm:border-b-2 sm:border-r-0 md:rounded-xl">
      <figure class="sm:aspect-4/3 shrink-0 w-24 min-h-24 overflow-hidden sm:w-full">
        <MoleculePicture class="v-hover-zoom-image w-full h-full object-cover transform transition duration-200" :image="image" :alt="imgAlt" />
      </figure>
      <section class="text-black relative flex flex-1 flex-col justify-center p-4 pr-12 leading-tight sm:justify-start sm:leading-snug md:p-8 md:pr-16 md:text-lg xl:text-xl">
        <h3 class="font-semibold sm:font-bold">{{ title }}</h3>
        <span v-if="subtitle" v-html="truncate(subtitle)" />
        <AtomIconArrowRight
          class="absolute bottom-0 right-0 mb-4 mr-4 w-3 h-3 text-app-green transform group-hover:translate-x-1 transition duration-200 sm:w-4 sm:h-4 md:mb-6 md:mr-6 md:w-5 md:h-5"
        />
      </section>
    </AtomLink>
  </article>
</template>

<script setup lang="ts">
import { truncate } from '~/composables/util'

interface Props {
  url: string
  title: string
  subtitle?: string
  image?: object
  imgAlt?: string
}

defineProps<Props>()
</script>
